module.exports = __webpack_public_path__ + "static/media/CA18.81641fcb.jpg";